let counter = 1;

export const nextModelId = () => counter++;
